module.exports = __webpack_public_path__ + "static/media/health-telemed.2826246f.svg";